import { render, staticRenderFns } from "./checkDeatil.vue?vue&type=template&id=53125371&scoped=true"
import script from "./checkDeatil.vue?vue&type=script&lang=js"
export * from "./checkDeatil.vue?vue&type=script&lang=js"
import style0 from "./checkDeatil.vue?vue&type=style&index=0&id=53125371&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53125371",
  null
  
)

export default component.exports